/** NOSONAR
 * Interface para uma pilha.
 *
 * Estrutura de dados baseada no princípio LIFO (Last In, First Out).
 *
 * Ver: https://en.wikipedia.org/wiki/Stack_(abstract_data_type)
 * Ver: https://web.archive.org/web/20251106141036/https://www.geeksforgeeks.org/typescript/how-to-create-a-stack-in-typescript-using-an-array/
 * Ver: https://web.archive.org/web/20251106141345/https://dev.to/glebirovich/typescript-data-structures-stack-and-queue-hld
 */
interface StackInterface<T> {
    push(item: T): void;
    pop():         T | undefined;
    peek():        T | undefined;
    size():        number;
}

/** NOSONAR
 * Implementação de uma pilha.
 *
 * Estrutura de dados baseada no princípio LIFO (Last In, First Out).
 *
 * Ver: https://en.wikipedia.org/wiki/Stack_(abstract_data_type)
 * Ver: https://web.archive.org/web/20251106141036/https://www.geeksforgeeks.org/typescript/how-to-create-a-stack-in-typescript-using-an-array/
 * Ver: https://web.archive.org/web/20251106141345/https://dev.to/glebirovich/typescript-data-structures-stack-and-queue-hld
 */
export class Stack<T> implements StackInterface<T> {
    private storage: T[] = []; // NOSONAR

    constructor(private readonly capacity: number = Infinity) {
        // Construtor intencionalmente vazio
    }

    /**
     * Adiciona um elemento no topo da pilha.
     *
     * @param item elemento a ser adicionado
     */
    push(item: T): void {
        if (this.size() === this.capacity) {
            throw new Error("Stack has reached max capacity.");
        }

        this.storage.push(item);
    }

    /**
     * Remove um elemento do topo da pilha.
     *
     * @returns elemento removido.
     */
    pop(): T | undefined {
        return this.storage.pop();
    }

    /**
     * Verifica o topo da pilha (sem removê-lo).
     *
     * @returns o topo da pilha.
     */
    peek(): T | undefined {
        return this.storage[this.size() - 1];
    }

    /**
     * Verifica o tamanho da pilha.
     *
     * @returns tamanho da pilha.
     */
    size(): number {
        return this.storage.length;
    }
}
